import { Button, Grid, MenuItem, TextField } from "@mui/material";
import { useMaterialUIController } from "context";
import React, { useState, useEffect } from "react";
import getText from "Translator";

import Swal from "sweetalert2";
import { updateForm } from "controllers/MenuController";
import { storeForm } from "controllers/MenuController";
import { displayErrorMessage } from "controllers/validation";
import LoadingOverlay from "react-loading-overlay";

const NewForm = (props) => {
  const [controller] = useMaterialUIController();
  const { handleClose, getData, mode, capsule } = props;
  const [formType, setFormType] = useState(1);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  const SubmitFormHandler = async () => {
    try {
      if (mode === "newform") {
        let newForm = {
          capsule: capsule,
          text,
          formType,
        };
        setLoading(true);
        let data = await storeForm(controller.lang, newForm, controller.token);
        setLoading(false);
        if (data.success) {
          Swal.fire({
            // text: "Insert Succesfully",
            text: data.message,
            position: "top-end",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          handleClose();
          getData();
        } else {
          Swal.fire({
            text: data.message,
            confirmButtonText: getText("ok", controller.lang),
            icon: "error",
          });
        }
      } else {
        editForm();
      }
    } catch (err) {
      displayErrorMessage(controller.lang);
    }
  };
  const editForm = async () => {
    try {
      let newForm = {
        form: props.id,
        capsule: capsule,
        text,
        formType,
        lang: controller.lang,
      };
      setLoading(true);
      let data = await updateForm(controller.lang, newForm, controller.token);

      setLoading(false);
      if (data.success) {
        Swal.fire({
          text: "Update Succesfully",
          position: "top-end",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
        handleClose();
        getData();
      } else {
        Swal.fire({
          text: data.message,
          confirmButtonText: getText("ok", controller.lang),
          icon: "error",
        });
      }
    } catch (err) {
      displayErrorMessage(controller.lang);
    }
  };
  useEffect(() => {
    setFormType(2);
    setText("");
    if (mode === "editform") {
      setFormType(props.formType);
      setText(props.text);
    }
  }, []);
  return (
    <Grid container>
      <LoadingOverlay
        active={loading}
        spinner
        text={getText("loading", controller.lang)}
      >
        <Grid item xs={12} sm={12} md={12}>
          {getText("formtype", controller.lang)}
          <TextField
            id="formType"
            fullWidth
            style={{ minWidth: 350 }}
            onChange={(event) => {
              setFormType(event.target.value);
            }}
            select
            variant="outlined"
            value={formType}
            disabled={mode === "newform" ? false : true}
          >
            {mode !== "newform" && (
              <MenuItem key={1} value={1} disabled={true}>
                Main Category
              </MenuItem>
            )}
            <MenuItem key={2} value={2}>
              {getText("subform", controller.lang)}
            </MenuItem>
            <MenuItem key={3} value={3}>
              {getText("helpform", controller.lang)}
            </MenuItem>
            {mode !== "newform" && (
              <MenuItem key={4} value={4} disabled={true}>
                {getText("resultform", controller.lang)}
              </MenuItem>
            )}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={12} md={12} style={{ marginTop: 15 }}>
          {getText("text", controller.lang)}
          <TextField
            id="text"
            fullWidth
            variant="outlined"
            value={text}
            onChange={(event) => {
              setText(event.target.value);
            }}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          mt={2}
          style={{
            flexDirection: "row",
            textAlign: controller.direction == "ltr" ? "right" : "left",
          }}
        >
          <Button color="secondary" onClick={handleClose}>
            {getText("cancel", controller.lang)}
          </Button>
          <Button color="primary" onClick={SubmitFormHandler}>
            {getText("submit", controller.lang)}
          </Button>
        </Grid>
      </LoadingOverlay>
    </Grid>
  );
};
export default NewForm;
